export let agPoolController: UseAGPoolController | null = null;

export const setAGPoolController = (controller: UseAGPoolController): void => {
    agPoolController = controller;
};
